var environment = {
    getEnv: function () {
        var env = '';
        switch (process.env.CROSS_ENV) {
            case 'dev':
            case 'development':
                env = 'dev-';
                break;
            case 'test':
                env = 't-';
                break;
            case 'prepare':
                env = 'pre-';
                break;
            default:
                env = '';
                break;
        }
        return env;
    },
    getApiEnv: function () {
        var apiEnv = this.getEnv();
        if (apiEnv === 'dev-' && process.env.CROSS_ENV !== 'development') {
            apiEnv = 't-';
        }
        return apiEnv;
    },
    getApigateWay: function () {
        var apiEnv = this.getApiEnv();
        var url = "https://" + apiEnv + "apigateway.gaodun.com";
        return url;
    },
};

var cookie = {
    setCookieV2: function (cookieOption) {
        if (!cookieOption.time) {
            cookieOption.time = 1.5 * 3600;
        }
        var exp = new Date();
        exp.setTime(exp.getTime() + cookieOption.time * 1000);
        cookieOption.value = encodeURIComponent(cookieOption.value);
        var hostname = cookieOption.domain ? cookieOption.domain : '.gaodun.com';
        document.cookie = cookieOption.key + '=' + cookieOption.value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
    },
    setCookie: function (key, value, time) {
        if (!time) {
            time = 3 * 24 * 60 * 60;
        }
        var exp = new Date();
        exp.setTime(exp.getTime() + time * 1000);
        value = encodeURIComponent(value);
        var hostname = '.gaodun.com';
        document.cookie = key + '=' + value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
    },
    getCookie: function (name) {
        var arr;
        var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        arr = document.cookie.match(reg);
        if (arr) {
            return decodeURIComponent(arr[2]);
        }
        else {
            return '';
        }
    },
    /**获取token对象，可以拿到过期时间和生效时间 */
    getCookieObj: function (name) {
        var token = cookie.getCookie(name);
        if (!token) {
            return null;
        }
        var res = token.split('.');
        var res2 = atob(res[1]);
        var tokenObj = JSON.parse(res2);
        return tokenObj;
    },
    delCookie: function (name) {
        this.setCookie(name, '', -1);
    },
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

export { _extends as _, cookie as c, environment as e };
